function OurProducts() {
  return (
    <div className="products-section">
      <h1>Our Products</h1>

      <div className="products-container">

        <div className="product-card">
          <img src="https://cdn-icons-png.flaticon.com/512/2933/2933245.png" />
          <h3>Solar Panels</h3>
          <p>High efficiency panels for maximum energy output.</p>
        </div>

        <div className="product-card">
          <img src="https://cdn-icons-png.flaticon.com/512/1048/1048953.png" />
          <h3>Inverters</h3>
          <p>Convert solar energy into usable electricity.</p>
        </div>

        <div className="product-card">
          <img src="https://cdn-icons-png.flaticon.com/512/3103/3103446.png" />
          <h3>Batteries</h3>
          <p>Reliable storage solutions for uninterrupted power.</p>
        </div>

      </div>
    </div>
  );
}

export default OurProducts;